import React, { Fragment } from "react";
import { useQuery, useMutation, useLazyQuery } from "@apollo/react-hooks";
import { useParams } from "@reach/router";
import styles from "./SubcategoryHome.module.scss";
import bookIcon from "../../../../images/book-icon.png";
import { Link } from "@reach/router";
import { Delete, Edit, Eye, EyeOff } from "react-feather";
import { navigate } from '@reach/router';

import { Loader } from "@squirrellearningltd/go-teacher-components";

import {
  DELETE_BOOK_MUTATION,
  GET_BOOK_TYPE_QUERY,
  GET_BOOK_TEMPLATE_USAGE_COUNT,
  HIDE_BOOK_TEMPLATE,
} from "../../services/graphql";
import BackLink from "../../../../components/BackLink";

const BookUsage = ({ bookId }) => {
  const { data, error, loading } = useQuery(GET_BOOK_TEMPLATE_USAGE_COUNT, {
    variables: { bookTemplateId: bookId }
  });

  if (loading) return "Loading...";
  if (error) return "Error";
  return data?.bookTemplateUsageCount || 0;
};

const SubcategoryHome = () => {
  const { subcategoryId } = useParams();
  const { data, error, loading } = useQuery(GET_BOOK_TYPE_QUERY, {
    variables: {
      bookTemplateCategoryId: subcategoryId,
    },
  });

   const [hideBookTemplate] = useMutation(HIDE_BOOK_TEMPLATE, {
      update: (_, { data }) => {
          if (
              data.hideBookTemplate.errors &&
              data.hideBookTemplate.errors.length
          ) {
              alert(data.hideBookTemplate.errors[0]);
          }
      },
      refetchQueries: [
        { query: GET_BOOK_TYPE_QUERY, variables: { bookTemplateCategoryId: subcategoryId } },
      ],
      awaitRefetchQueries: true,
  });

  const [deleteBook] = useMutation(DELETE_BOOK_MUTATION, {
    update: (_, { data }) => {
      if (
        data.deleteBookTemplate.errors &&
        data.deleteBookTemplate.errors.length
      ) {
        alert(data.deleteBookTemplate.errors[0]);
      }
    },
    refetchQueries: [
      { query: GET_BOOK_TYPE_QUERY, variables: { bookTemplateCategoryId: subcategoryId } },
    ],
    awaitRefetchQueries: true,
  });

  const onDeleteBook = (book) => {
    let goAhead = window.confirm(
      `Are you sure you want to delete ${book.name}?`
    );
    if (goAhead) {
      deleteBook({
        variables: {
          bookTemplateId: book.id,
        },
      });
    }
  };

 const onHideBookTemplate = (book) => {
    const newVisibility = !book.isVisible;
    const action = newVisibility ? 'show' : 'hide';
    
    let goAhead = window.confirm(
      `Are you sure you want to ${action} ${book.name}?`
    );
    
    if (goAhead) {
      hideBookTemplate({
        variables: {
          bookTemplateId: book.id,
          isVisible: newVisibility,
        },
      });
    }
  };

  if (error) {
    return <p>{error.message}</p>;
  }

  if (loading) {
    return <Loader />;
  }
  if (data && data.bookTemplateCategory) {
    return (
      <Fragment>
        <div className={styles.sectionHeader}>
          <div className={styles.titleIconContainer}> 
            <h1 className={styles.headerTitle}>Categories/Subcategories</h1>
            <img width="20" height="20" src={bookIcon} alt="book-icon-png" />
          </div>
          <BackLink to={`/packs`} text="Back" />
        </div>
        <div className={styles.categoryRounte}>
          <div className={styles.titleIconContainer}>
            <div
              className={`${styles.titleBox} ${styles.moveRight}`}
              style={{
                backgroundColor: data?.bookTemplateCategory?.backgroundColor,
                color: data?.bookTemplateCategory?.textColor,
              }}
            >
              <img
                className={styles.ImageContainer}
                src={data.bookTemplateCategory.iconUrl}
                alt="book-icon-png"
              />
              <h3>Categories</h3>
            </div>
            <div
              className={styles.titleBox}
              style={{
                backgroundColor: data?.bookTemplateCategory?.backgroundColor,
                color: data?.bookTemplateCategory?.textColor,
              }}
            >
              <img
                className={styles.ImageContainer}
                src={data.bookTemplateCategory.iconUrl}
                alt="book-icon-png"
              />
              <h3>Subcategories</h3>
            </div>
          </div>
          <Link
            to={`/book/${subcategoryId}/new`}
            className={styles.createButton}
          >
            Create New
          </Link>
        </div>
        <div>
          <table>
            <thead>
              <tr>
                <th>Title</th>
                <th>Age Range</th>
                <th>Usage</th>
                <th>Visibility</th>
                <th>Edit</th>
                <th>Delete</th>
              </tr>
            </thead>
            <tbody>
              {data.bookTemplateCategory.bookTemplates.map((book) => (
                <tr key={book.id}>
                  <td>{book.name}</td>
                  <td>{book.targetAge}</td>
                  <td><BookUsage bookId={book.id} /></td>
                  <td> 
                    {book.isVisible ? (
                      <Eye
                        className={styles.listItemRightButton}
                        onClick={() => onHideBookTemplate(book)}
                        style={{ cursor: "pointer" }}
                      />
                    ) : (
                      <EyeOff
                        className={styles.listItemRightButton}
                        onClick={() => onHideBookTemplate(book)}
                        style={{ cursor: "pointer" }}
                      />
                    )}
                  </td>
                  <td>
                    <Edit
                      className={styles.listItemRightButton}
                      onClick={() => navigate(`/book/${subcategoryId}/${book.id}`)}
                      style={{ cursor: "pointer" }}
                    />
                  </td>
                  <td>
                    <Delete
                      className={styles.listItemRightButton}
                      onClick={() => onDeleteBook(book)}
                      style={{ cursor: "pointer" }}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Fragment>
    );
  }
};

export default SubcategoryHome;
